var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestmanagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8V13C3 16.771 3.001 18.656 4.172 19.828C5.343 21 7.229 21 11 21H13C16.771 21 18.656 20.999 19.828 19.828C21 18.657 21 16.771 21 13V8M3 8H21M3 8L3.865 6.077C4.537 4.585 4.872 3.84 5.552 3.42C6.232 3 7.105 3 8.85 3H15.15C16.895 3 17.767 3 18.448 3.42C19.128 3.84 19.463 4.585 20.135 6.077L21 8M12 8V3",
    stroke: "#626F86",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.5H14C14.5304 13.5 15.0391 13.7107 15.4142 14.0858C15.7893 14.4609 16 14.9696 16 15.5C16 16.0304 15.7893 16.5391 15.4142 16.9142C15.0391 17.2893 14.5304 17.5 14 17.5H13M10 11.5L8 13.5L10 15.5",
    stroke: "#626F86",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestmanagement);
export default __webpack_public_path__ + "static/media/requestmanagement.9cb4122a0edbb86b2dd9da2a1ecdc02b.svg";
export { ForwardRef as ReactComponent };